import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "is-required"
}
const _hoisted_4 = {
  key: 1,
  class: "c-label-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return ($props.inputLabel)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(["d-control-input__label", {'d-control-input__label--active': $setup.isValue && !$props.isStaticLabel }]),
        for: $props.id
      }, [
        _createElementVNode("span", {
          class: "d-control-input__label-text",
          title: $props.inputLabel
        }, _toDisplayString($props.inputLabel), 9, _hoisted_2),
        ($props.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
          : _createCommentVNode("", true),
        ($props.hint)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_AppIcon, {
                name: "i-info-circle",
                size: "sm"
              })
            ])), [
              [_directive_tooltip, $props.hint]
            ])
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}